import type { ThemeState, ThemeName } from './types';

export interface ThemeStore {
  theme: ThemeState;
}

export const selectThemeName = (store: ThemeStore): ThemeName => store.theme.name;
